<template>
  <div class="full">
    <div class="back" @click="goBack()">
      返回首页
    </div>
    <div class="box">
     
      <div class="goback" @click="goBack()"> 返回
      </div>
      <h2 class="box1">{{ title }}</h2>

      <div class="line"></div>
      <p class="box3">{{ fulltext }}</p>

      <div class="box2">
        <span class="author">
          <img src="../assets/images/qasource.png" alt="" />
          {{ author }}</span
        >
        <span class="date">
          <img src="../assets/images/qadate.png" alt="" />
          {{ date.slice(0,15) }}</span
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.getParams();
  },
  methods: {
    goBack(){
      if(this.fromPage == 'home'){
        this.$router.push({ name: 'home', query: { scrollTo: 'qa' , tab: this.tabIndex} });
      }else if(this.fromPage == 'qa'){
        this.$router.push({ name: 'qapage', query: {from: this.fromIndex, page:this.page, tab: this.tabIndex} });
      }
    },
    getParams() {
      window.scrollTo(0, 0);
      this.title = this.$route.query.title;
      this.author = this.$route.query.author;
      this.date = this.$route.query.date;
      this.fulltext = this.$route.query.fulltext;
      this.fromPage = this.$route.query.from;
      this.tabIndex = this.$route.query.tab;
      this.page = this.$route.query.page;
      this.fromIndex = this.$route.query.index;
    },
  },
  data() {
    return {
      fromIndex:'',
      page:'',
      title: "",
      author: "",
      date: "",
      fromPage : '',
      tab: '',
      fulltext: "",
    };
  },
  mounted() {
    // document.querySelector("ecp_top-nav").style.display = "none";
  },
};
</script>

<style lang="scss" scoped>
.full {
  width: 100%;
  min-height: 700px;
  background: #f6f8fa;
  padding-top: 40px;
  padding-bottom: 40px;
  .box {
    position: relative;
    width: 1240px;
    margin: 0 auto;
    background: #ffffff;
    border-radius: 16px 16px 16px 16px;
    padding-top: 40px;
    padding-bottom: 40px;

    .goback{
      position: absolute;
      right: 20px;
      top: 20px;
      cursor: pointer;
      color: #8a8f8d;
    }
    .goback:hover{
      color: #262626;
    }
    .box1 {
      max-width: 960px;
      margin: 0 auto;
      text-align: center;
      font-size: 28px;
      color: #262626;
      line-height: 42px;
    }
    .box2 {
      max-width: 960px;
      margin: 40px auto;
      text-align: center;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 20px;
      .author {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        color: #8a8f8d;
        line-height: 24px;
        text-align: center;
      }
      .date {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        color: #8a8f8d;
        line-height: 24px;
        text-align: center;
      }
      img {
        width: 16px;
        height: 16px;
        margin-right: 4px;
      }
    }
    .box3 {
      width: 960px;
      text-indent: 2em;
      height: auto;
      margin: 40px auto;
      font-size: 20px;
      color: #262626;
      line-height: 50px;
      word-break: break-all;
      text-align: justify;
    }
    .line {
      width: 1000px;
      height: 1px;
      background-color: #d0d0d0;
      margin: 40px auto;
    }
  }

  .back {
    cursor: pointer;
    position: absolute;
    top: 100px;
    left: 0;
    width: 88px;
    height: 38px;
    background: #ffffff;
    box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.04),
      0px 0px 14px 0px rgba(0, 0, 0, 0.1);
    border-radius: 0px 8px 8px 0px;
    font-size: 14px;
    color: #262626;
    line-height: 38px;
    text-align: center;
  }
  .back:hover{
    color:#4175f4;
  }
}
</style>>

